export const getInitials = function (fullName) {
  let initials = "";
  const names = fullName.split(" ");
  names.forEach((name) => {
    initials += name[0];
  });

  return initials;
};
